/* Publish by EComposer at 2026-10-06 02:25:08*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-e72ex6h31b"]=  window.__ectimmers["ecom-e72ex6h31b"] || {};
const t=this.$el;if(!t||!this.isLive)return;const e=t.querySelector(".element__featured--wrapper-list");if(e){let i={top:0,left:0,x:0,y:0};const o=function(r){const a=r.clientX-i.x;e.scrollLeft=i.left-a},n=function(){e.removeEventListener("mousemove",o),e.removeEventListener("mouseup",n),e.style.cursor="default",e.style.removeProperty("user-select")},s=function(r){e.style.cursor="grabbing",e.style.userSelect="none",i={left:e.scrollLeft,top:e.scrollTop,x:r.clientX,y:r.clientY},e.addEventListener("mousemove",o),e.addEventListener("mouseup",n)};e.addEventListener("mousedown",s),e.addEventListener("mouseleave",n)}

                    });
                    
                        document.querySelectorAll('.ecom-e72ex6h31b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-e72ex6h31b', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-e3s4o61c9y').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-e3s4o61c9y', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-wmw8q2vs3wj"]=  window.__ectimmers["ecom-wmw8q2vs3wj"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const o=t.querySelector(".ecom__element--button");if(!o)return;let n=parseInt(i.settings.animation_loop_time)*1e3||6e3,s=1e3;window.__ectimmers["ecom-wmw8q2vs3wj"]["znht8as1o"] = setInterval(function(){o.classList.add("animated"),setTimeout(function(){o.classList.remove("animated")},s)},n)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let o=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const n=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},o);try{Shopify.analytics.publish("ec_custom_events",n)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const s=e.getAttribute("href"),r=e.getAttribute("target");s&&s!=="#"&&s!=="javascript:void(0)"&&(r==="_blank"?window.open(s,"_blank"):setTimeout(function(){window.location.href=s},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-wmw8q2vs3wj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wmw8q2vs3wj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bm2uc00grkl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bm2uc00grkl', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-uk73ditf8po').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uk73ditf8po', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-19tg8onxwux').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-19tg8onxwux', settings: {},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}